import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('gdprSupplyTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allValues: '<',
      valueSelections: '<',
      paramRequired: '<',
      readOnly: '<',
      valueMappings: '<'
    },
    template: require("../templates/gdprSupplyTargeting.html"),
    controllerAs: '$gdprSupplyTargetingCtrl',
    controller: function() {
      this.allCustomOptions2 = componentHelper.allCustomOptions2();
    }
});
